import React, {useEffect} from 'react';
import {Link} from "react-router-dom";

const PreviousNext = ({handleMenuClick, previous, next}) => {
  
  return(
    <section id="previous-next">
      <div>
        <Link to={`/portfolio/${previous.title}`}>
          <img src="images/icons/arrow-left.png"/>
          
          <div>
            <h3 id={previous.title} onClick={handleMenuClick}>
              {previous.title}
            </h3>
            
            <p className="body1 opacity50">
              Previous Project
            </p>
          </div>
        </Link>
      </div>
    
      <div>
        <Link to={`/portfolio/${next.title}`}>
          <img src="images/icons/arrow-right.png"/>
          
          <div>
            <h3 id={next.title} onClick={handleMenuClick}>
              {next.title}
            </h3>
            
            <p className="body1 opacity50">
              Next Project
            </p>
          </div>
        </Link>
      </div>
    </section>
  );
}
  
  export default PreviousNext;